const common = {
  siteName: '韩国伦理文化研究',
  siteDescription: '深度解析韩国伦理文化与价值观',
  home: '首页',
  categories: '分类',
  about: '关于我们',
  readMore: '阅读全文',
  latestArticles: '最新文章',
  featuredArticles: '精选文章',
  relatedArticles: '相关文章',
  allCategories: '全部分类',
  backToHome: '返回首页',
  searchPlaceholder: '搜索文章...',
  readTime: '分钟阅读',
  publishedOn: '发布于',
  author: '作者',
  shareArticle: '分享文章',
  viewAll: '查看全部',
  contactUs: '联系我们',
  brandIntroduction: '品牌介绍',
  reputation: '品牌声誉',
  noArticles: '暂无文章',
  loading: '加载中...',
  error: '加载失败',
  retry: '重试',
  scrollToTop: '回到顶部',
};

export default common;